import * as React from 'react';

function SvgAlarm(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path
        className="alarm_svg__st0"
        d="M35.5 52.6c-1 0-1.8-.8-1.9-1.8l-1.3-18.1c-.1-1-.1-2.7-.1-3.7v-6.4c0-1 .8-1.8 1.8-1.8h3c1 0 1.8.8 1.8 1.8V29c0 1-.1 2.7-.1 3.7l-1.3 18.1c-.1.9-.9 1.8-1.9 1.8zm-1.2 11c-1 0-1.8-.8-1.8-1.8v-4.6c0-1 .8-1.8 1.8-1.8h2.5c1 0 1.8.8 1.8 1.8v4.6c0 1-.8 1.8-1.8 1.8h-2.5z"
      />
      <path
        className="alarm_svg__st0"
        d="M68.8 70.7H3c-.7 0-1.3-.4-1.6-1.1-.3-.7-.3-1.5 0-2.1L34.3 2C35 .6 36.8.6 37.5 2l32.9 65.6c.3.7.3 1.5 0 2.1-.3.6-.9 1-1.6 1zM7.3 66.2h57.4L35.9 9.4 7.3 66.2z"
      />
    </svg>
  );
}

export default SvgAlarm;
